/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2019 ICEMEDX, Inc.
***********************************************/
import { Component, OnInit, Input, ChangeDetectorRef, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatTableDataSource } from '@angular/material';

import {
  IcecontrolSettings,
  IcemattableSettings,
  IcepanelgroupSettings,
  IcepanelsectionSettings,
  IcepanelSettings,
  IcepanelcontainerRowSettings,
  IcepanelcontainerSettings,

  iceColumnDefinition,
  SECTION_CONTROL_ALIGNMENT
} from '../../../../icemedx-lib/src/components/models/icesettings';

import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';

import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { AppService } from '../app.service';
import { ReportService } from 'projects/icemedx-lib/src/services/report/report.service';
import { ScheduleService } from 'projects/icemedx-lib/src/services/schedule/schedule.service';
import { MedicalcodesService } from 'projects/icemedx-lib/src/services/medicalcodes/medicalcodes.service';

import { report, Report_Layout_Type, Report_Mode_Type } from '../../../../icemedx-lib/src/models/reports/report';
import { IceTypes } from '../../../../icemedx-lib/src/models/icetypes';
import { reporttemplate } from 'projects/icemedx-lib/src/models/reports/reporttemplate';
import { reportfilter, OperatorTypes } from 'projects/icemedx-lib/src/models/reports/subs/reportfilter';
import { lodgemembershipsummary } from '../../../../icemedx-lib/src/models/stats/lodgemembshipsummary';
import { LoginService } from '../../../../icemedx-lib/src/login/login.service';
import { DomainService } from '../../../../icemedx-lib/src/services/domain/domain.service';
import { provider } from '../../../../icemedx-lib/src/models/domain/provider';
import { pharmacy } from '../../../../icemedx-lib/src/models/domain/pharmacy';
import { payer } from '../../../../icemedx-lib/src/models/domain/payer';
import { basecode } from '../../../../icemedx-lib/src/models/ehr/subs/basecode';
import { vendor } from '../../../../icemedx-lib/src/models/domain/vendor';
import { patient } from '../../../../icemedx-lib/src/models/domain/patient';
import { IcepanelDialog } from '../../../../icemedx-lib/src/components/icepaneldialog/icepaneldialog';
import { CustomFormService } from '../../../../icemedx-lib/src/services/custom/customform.service';
import { ITabProperties } from '../../../../icemedx-lib/src/components/icetab/ITabProperties';
import { notebookpageindex } from '../../../../icemedx-lib/src/models/customforms/notebookpageindex';
import { notebookpage } from '../../../../icemedx-lib/src/models/customforms/notebookpage';
import { NotebookObject } from '../../../../icemedx-lib/src/components/models/notebookobject';
import { NotebookPageObject } from '../../../../icemedx-lib/src/components/models/notebookpageobject';
import { notebookpagetotype } from '../../../../icemedx-lib/src/models/customforms/notebookpagetotype';

const NameOfReport: string = "NameOfReport";
const TypeOfReport: string = "TypeOfReport";
const RunFrequency: string = "RunFrequency";
const CancelReport: string = "CancelReport";
const SaveReport: string = "SaveReport";
const FromDate: string = "FromDate";
const ToDate: string = "ToDate";

const TemplatePanelSummary: string = "TemplatePanelSummary";
const TemplateTypeSection: string = "TemplateTypeSection";
const TemplateType: string = "report_template_type";

const TemplatePanelForm: string = "TemplatePanelForm";
const TemplateFormSection: string = "TemplateFormSection";
const TemplateFormSelect: string = "notebook_index_key";
const TemplateFormTextSection: string = "TemplateFormTextSection";
const TemplateFormPlainText: string = "TemplateFormPlainText";
const TemplateCustomFormSection: string = "TemplateCustomFormSection";

const TemplatePanelFilters: string = "TemplatePanelFilters";

const TemplateCustomData: string = "TemplateCustomData";
const TemplateCustomReport: string = "TemplateCustomReport";

class TabPropertyBase implements ITabProperties {
  label: string = "";
  content: string = "";
  id?: string = null;
  isHtmlContent: boolean = true;
  constructor(lbl: string, cntnt: string, htmlCntnt: boolean, id: string = null) {
    this.label = lbl;
    this.content = cntnt;
    this.id = id;
    this.isHtmlContent = htmlCntnt;
  }
}

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss'],
  providers: [IceNavService, AppService]
})
export class ReportComponent implements OnInit {
  @Input() reportKey: string = "";
  @Input() panelSync: IcepanelSettings = null;
  @Input() showBreadcrum: boolean = true;

  // Currency and Currencies
  countries: basecode[] = [];
  currencies: basecode[] = [];
  reportTemplateOptions: any[] = [];

  // data members
  reportObj: report = new report();
  templateDataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  apiToUse: string = "";
  reportDomainType: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  reportDomain: string = "";

  templateDialogRef: any = null;
  customFormDialogRef: any = null;
  addTemplateButtonCtrl: IcecontrolSettings = new IcecontrolSettings("AddTemplateButton", { text: "Add Template", class: [], glyphClass: "fa-plus-circle" }, null, null);

  // report member settings
  reportMode: Report_Mode_Type = Report_Mode_Type.modeDesign;
  reportLayoutType: Report_Layout_Type = Report_Layout_Type.rltStaticLayout;

  nameOfReportCtrl: IcecontrolSettings = null;
  typeOfReportCtrl: IcecontrolSettings = null;
  runFrequencyCtrl: IcecontrolSettings = null;
  fromDateCtrl: IcecontrolSettings = null;
  toDateCtrl: IcecontrolSettings = null;
  reportPanelSettings: IcepanelSettings = null;
  reportSections: IcepanelsectionSettings[] = null;

  reportViewSettings: IcepanelcontainerSettings = null;

  // Template View
  templateTabSummary: string = "TemplateTabSummary";
  templateTabFilter: string = "TemplateTabFilter";
  templateTabForm: string = "TemplateTabForm";
  templateTabReport: string = "TemplateTabReport";
  templateSummaryTab: TabPropertyBase = new TabPropertyBase("Summary", "", true, this.templateTabSummary);
  templateFilterTab: TabPropertyBase = new TabPropertyBase("Filter", "", true, this.templateTabFilter);
  templateFormTab: TabPropertyBase = new TabPropertyBase("Additional Information", "", true, this.templateTabForm);
  templateReportTab: TabPropertyBase = new TabPropertyBase("Report Format", "", true, this.templateTabReport);

  templateTabCtrl: any = null;
  selectedTemplateTab: any = {};
  templateSummaryViewSettings: any = {};
  templateFilterViewSettings: any = {};
  templateFormViewSettings: any = {};

  allForms: any = {};

  // Lodge Membership Data
  lodgeSummary_memberShipReportDateCtrl: any = {};
  lodgeSummary_nameOfOrgCtrl: any = {};
  lodgeSummary_address1OfOrgCtrl: any = {};
  lodgeSummary_address2OfOrgCtrl: any = {};
  lodgeSummary_cityOfOrgCtrl: any = {};
  lodgeSummary_postalCodeOfOrgCtrl: any = {};
  lodgeSummary_countryOfOrgCtrl: any = {};
  lodgeSummary_stateOfOrgCtrl: any = {};
  lodgeSummary_provinceOfOrgCtrl: any = {};
  lodgeSummary_charterNumberCtrl: any = {};
  lodgeSummary_memberShipReportStartDateCtrl: any = {};
  lodgeSummary_memberShipReportEndDateCtrl: any = {};
  lodgeSummary_functioningStatusCtrl: any = {};
  lodgeSummary_numberOfMembersCtrl: any = {};
  lodgeSummary_activeMembersCtrl: any = {};
  lodgeSummary_meetingLocationCtrl: any = {};
  lodgeSummary_activitiesCtrl: any = {};
  lodgeSummary_otherActivitiesCtrl: any = {};
  lodgeSummary_transferName1Ctrl: any = {};
  lodgeSummary_transferTo1Ctrl: any = {};
  lodgeSummary_transferEffectiveDate1Ctrl: any = {};
  lodgeSummary_transferName2Ctrl: any = {};
  lodgeSummary_transferTo2Ctrl: any = {};
  lodgeSummary_transferEffectiveDate2Ctrl: any = {};
  lodgeSummary_remitPeriodCtrl: any = {};
  lodgeSummary_remittedAmountCtrl: any = {};
  lodgeSummary_suggestionsCtrl: any = {};

  getAppService(): AppService {
    return this.appSvc;
  }

  getNavService(): IceNavService {
    return this.navSvc;
  }

  getLoginService(): LoginService {
    return this.loginSvc;
  }

  getReportService(): ReportService {
    return this.rptService;
  }

  getRouter(): Router {
    return this.router;
  }

  getCodeService(): MedicalcodesService {
    return this.codeSvc;
  }

  getReportMode(): Report_Mode_Type {
    return this.reportMode;
  }
  setReportMode(rptMode: Report_Mode_Type): void {
    this.reportMode = rptMode;
  }

  getReportLayoutType(): Report_Layout_Type {
    return this.reportLayoutType;
  }
  setReportLayoutType(rptLayoutType: Report_Layout_Type): void {
    this.reportLayoutType = rptLayoutType;
  }

  getReportDomainType(): IceTypes.ACCOUNT_TYPE {
    return this.reportDomainType;
  }
  getReportDomain(): string {
    return this.reportDomain;
  }

  loadReport(parm: any) {
    this.reportDomainType = IceTypes.ACCOUNT_TYPE.actNone;
    if (parm.domaintype == null)
      this.reportDomainType = this.appSvc.getCurrentAccountType();
    else
      this.reportDomainType = <IceTypes.ACCOUNT_TYPE>Iceutility.toLong(parm.domaintype);

    this.reportDomain = "";
    if (parm.domain == null)
      this.reportDomain = this.appSvc.getCurrentAccount();
    else
      this.reportDomain = parm.domain;


    this.apiToUse = this.getAPIBasePath(this.reportDomainType);

    switch (this.reportDomainType) {
      case IceTypes.ACCOUNT_TYPE.actProvider:
      case IceTypes.ACCOUNT_TYPE.actFacility: {
        this.domainSvc.getProvider(this.reportDomain).subscribe(
          data => {
            if (data != null && data.length > 0) {
              let pro: provider = data[0];
              this.currencies = pro.CURRENCIES;
              this.countries = pro.COUNTRIES;
            }
          },
          error => {
            // To do
          }
        );
        break;
      }
      case IceTypes.ACCOUNT_TYPE.actPharmacy: {
        this.domainSvc.getPharmacy(this.reportDomain).subscribe(
          data => {
            if (data != null && data.length > 0) {
              let phrm: pharmacy = data[0];
              this.currencies = phrm.CURRENCIES;
              this.countries = phrm.COUNTRIES;
            }
          },
          error => {
            // To do
          }
        );
        break;
      }
      case IceTypes.ACCOUNT_TYPE.actPayer: {
        this.domainSvc.getPayer(this.reportDomain).subscribe(
          data => {
            if (data != null && data.length > 0) {
              let pyr: payer = data[0];
              this.currencies = pyr.CURRENCIES;
              this.countries = pyr.COUNTRIES;
            }
          },
          error => {
            // To do
          }
        );
        break;
      }
      case IceTypes.ACCOUNT_TYPE.actVendor: {
        this.domainSvc.getVendor(this.reportDomain).subscribe(
          data => {
            if (data != null && data.length > 0) {
              let ven: vendor = data[0];
              this.currencies = ven.CURRENCIES;
              this.countries = ven.COUNTRIES;
            }
          },
          error => {
            // To do
          }
        );
        break;
      }
      case IceTypes.ACCOUNT_TYPE.actPatient: {
        this.domainSvc.getPatient(this.reportDomain, this.appSvc.getCurrentAccount()).subscribe(
          data => {
            if (data != null && data.length > 0) {
              let pt: patient = data[0];
              this.currencies = pt.CURRENCIES;
              this.countries = pt.COUNTRIES;
            }
          },
          error => {
            // To do
          }
        );
        break;
      }
    }

    this.rptService.getReport(this.apiToUse, this.reportDomain, this.reportDomainType, false, parm.key).subscribe(
      data => {
        if (data && data.length > 0 && data[0] != null) {
          this.reportViewSettings = this.viewSetup(data[0]);
        }
      },
      error => {
        console.log(JSON.stringify(this.rptService.getLastErrors()));
      });
  }

  constructor(private appSvc: AppService,
    private navSvc: IceNavService,
    private loginSvc: LoginService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private rptService: ReportService,
    private frmService: CustomFormService,
    private schService: ScheduleService,
    private codeSvc: MedicalcodesService,
    private domainSvc: DomainService,
    private changeDetectorRefs: ChangeDetectorRef,
    public dialog: MatDialog) {

    this.setReportMode(Report_Mode_Type.modePreview);
    if (this.panelSync == null)
      this.appSvc.defaultMenus();

    //this.appSvc.addBreadcrumb("Reports", {}, true, "/reports");
    //this.appSvc.addBreadcrumb("Report", {}, true, "");

    this.activatedRoute.params.subscribe(next => {
      if (next == null || next.key == "0" || next.length == 0) {
        this.reportViewSettings = this.viewSetup(null);
      }
      else {
        this.loadReport(next);
      }
    });
  }

  getAPIBasePath(domaintype: IceTypes.ACCOUNT_TYPE): string {
    let ret = "";
    switch (domaintype) {
      case IceTypes.ACCOUNT_TYPE.actFacility:
      case IceTypes.ACCOUNT_TYPE.actProvider:
        ret = "providers";
        break;
      case IceTypes.ACCOUNT_TYPE.actPharmacy:
        ret = "pharmacies";
        break;
      case IceTypes.ACCOUNT_TYPE.actPayer:
        ret = "payers";
        break;
      case IceTypes.ACCOUNT_TYPE.actPatient:
        ret = "patients";
        break;
      case IceTypes.ACCOUNT_TYPE.actVendor:
        ret = "vendors";
        break;
      default:
        this.rptService.logMessage(IceTypes.LOGTYPE.ltError, "Error reporting API not supported. ");
    }
    return ret;
  }

  getTemplates(): reporttemplate[] {


    return this.reportObj.RPTTEMPLATES;
  }

  createTemplateTab(template: reporttemplate): boolean {
    if (this.templateTabCtrl == null)
      this.templateTabCtrl = {};

    if (this.templateTabCtrl[template.report_template_key] == null) { // create tab control
      this.templateTabCtrl[template.report_template_key] = new IcecontrolSettings("icetab", { width: "100%", height: "100%", tabs: <ITabProperties[]>[this.templateSummaryTab, this.templateFilterTab, this.templateFormTab, this.templateReportTab], activeTabIndex: 0 }, null, null, "templateTabs" + template.report_template_key, "")
        .createFormControl(0, []);

      this.selectedTemplateTab[template.report_template_key] = this.templateTabSummary;
    }
    return true;
  }

  getTemplateName(template: reporttemplate): string {
    let fndTempl = this.reportTemplateOptions.filter(t => t.value == template.report_template_type);

    this.createTemplateTab(template);

    return fndTempl.length > 0 ? fndTempl[0].name : "";
  }

  getTemplateDescription(template: reporttemplate): string {
    return "";
  }

  getTemplateActions(template: reporttemplate): any[] {
    let actions: any[] = [];

    actions.push(IceTypes.recordQuickActionClone);
    actions.push(IceTypes.recordQuickActionRemove);
    return actions;
  }

  getTemplateActionClass(template: reporttemplate, action: any): any {
    if (action == null)
      return { "fas": true, "fa-question": true, "fa-3x": true };

    return action.iconClass;
  }

  isStandardTemplate(template: reporttemplate): boolean {
    let fndTempl = this.reportTemplateOptions.filter(t => t.value == template.report_template_type && t.code.indexOf("REPTEMPL-") >= 0);
    return fndTempl.length > 0;
  }

  isTemplateTabActive(id: string, template: reporttemplate): boolean {
    if (this.templateTabCtrl == null || this.templateTabCtrl[template.report_template_key] == null) return false;
    return this.selectedTemplateTab[template.report_template_key] == id;
  }

  getTemplateSummaryViewSettings(template: reporttemplate): IcepanelcontainerSettings {
    if (this.templateSummaryViewSettings[template.report_template_key] == null) {
      let tempSections = [];
      tempSections.push(
        new IcepanelsectionSettings(
          TemplateTypeSection, { class: [], styles: { width: "100%" } }, [], [
          new IcecontrolSettings("iceselect", { width: "250px" }, null, null, TemplateType + template.report_template_key, "Type of Template")
            .setControlName(TemplateType + template.report_template_key)
            .createFormControl(template.report_template_type, [Validators.required])
              .setOptions(this.reportTemplateOptions.filter(o => o.category_type == this.reportObj.report_type))
        ],
          null).setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical).setShow(true)
      );

      let headerControls = [
      ];

      let tempPanelSettings = new IcepanelSettings(TemplatePanelSummary, template.report_template_key, "Report Summary", "", tempSections, headerControls)
        .enableForm();
      let panels: IcepanelSettings[] = [
        tempPanelSettings
      ];

      let panelrows: IcepanelcontainerRowSettings[] = [new IcepanelcontainerRowSettings(panels)];
      this.templateSummaryViewSettings[template.report_template_key] = new IcepanelcontainerSettings("TemplateViewContainer", panelrows);
    }
    return this.templateSummaryViewSettings[template.report_template_key];
  }

  getTemplateFilterViewSettings(template: reporttemplate): IcepanelcontainerSettings {
    if (this.templateFilterViewSettings[template.report_template_key] == null) {
      let tempSections = [];

      /////////////////////////////////////////////////
      // Filters
      let fromVal = Iceutility.getDateTextEx(Iceutility.GetLocalDate());
      let toVal = fromVal;

      //REPTEMPL-OTHER
      let thisFilter = template.RPTFILTER[0]; // To do change this to loop through all filters
      if (thisFilter != null) {
        let parts = thisFilter.value.split(",");
        if (parts.length > 0)
          fromVal = parts[0];
        if (parts.length > 1)
          toVal = parts[1];
      }

      this.fromDateCtrl = new IcecontrolSettings("icedatepicker", { placeholder: "From Date", value: Iceutility.GetDateText(Iceutility.GetLocalDate()), timevalue: "00:00:00 AM" }, null, null, FromDate)
        .setControlName(FromDate)
        .createFormControl(Iceutility.GetLocalDate(fromVal), [Validators.required]);
      this.toDateCtrl = new IcecontrolSettings("icedatepicker", { placeholder: "To Date", value: Iceutility.GetDateText(Iceutility.GetLocalDate()), timevalue: "11:59:59 PM" }, null, null, ToDate)
        .setControlName(ToDate)
        .createFormControl(Iceutility.GetLocalDate(toVal), [Validators.required]);

      let dateFilterControls: IcecontrolSettings[] = [
        this.fromDateCtrl,
        this.toDateCtrl,
      ];

      tempSections.push(
        new IcepanelsectionSettings("DateFilterSection", { class: ["yalla"], styles: { width: "100%" } }, null,
          dateFilterControls, null).setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical).setShow(true)
      );

      let headerControls = [
      ];

      let tempPanelSettings = new IcepanelSettings(TemplatePanelFilters, template.report_template_key, "Report Filter(s)", "", tempSections, headerControls)
        .enableForm();
      let panels: IcepanelSettings[] = [
        tempPanelSettings
      ];

      let panelrows: IcepanelcontainerRowSettings[] = [new IcepanelcontainerRowSettings(panels)];
      this.templateFilterViewSettings[template.report_template_key] = new IcepanelcontainerSettings("TemplateViewContainer", panelrows);
    }
    return this.templateFilterViewSettings[template.report_template_key];
  }

  // getTemplateCustomReportViewSettings
  getTemplateFormViewSettings(template: reporttemplate): IcepanelcontainerSettings {
    if (this.templateFormViewSettings[template.report_template_key] == null) {
      let tempSections = [];

      debugger;
      let formSelectCtrl: IcecontrolSettings = null;
      let formDesignCtrl: IcecontrolSettings = null;
      let plainTextCtrl: IcecontrolSettings = null;
      let plainTextSection: IcepanelsectionSettings = null;
      let lodgeMemSummarySection: IcepanelsectionSettings = null;
      let customFormSection: IcepanelsectionSettings = null;
      let customFormControl: IcecontrolSettings = null;
      let customFormChange = new EventEmitter<any>();
      let noteBookOb = new NotebookObject(this.frmService, this.appSvc, this.codeSvc);
      let nbData = noteBookOb.getFieldData();
      if (nbData != null) {
        nbData[template.gettablename()] = template;
      }
      let lodgeMemSummary: lodgemembershipsummary = null;

      tempSections.push(
        new IcepanelsectionSettings(
          TemplateFormSection, { class: [], styles: { width: "100%" } }, [], [
            formDesignCtrl = new IcecontrolSettings("icebutton", { text: "Design", glyphClass: "fa-solid fa-ruler-combined", width: "50px" }, null, null, "DesignForm"),
            formSelectCtrl = new IcecontrolSettings("iceselect", { width: "300px" }, null, null, TemplateFormSelect + template.report_template_key, "Form")
              .setControlName(TemplateFormSelect + template.report_template_key)
              .createFormControl(template.notebook_page_key, [])
              .setOptions([{ name: "Textual Note", value: "" }])
        ],
          null).setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical).setShow(true)
      );

      tempSections.push(
        plainTextSection = new IcepanelsectionSettings(
          TemplateFormTextSection, { class: [], styles: { width: "100%" } }, [], [
            plainTextCtrl = new IcecontrolSettings("icetextarea", { width: "300px", rows: "20", cols: "40" }, null, null, TemplateFormPlainText + template.report_template_key, "Text Information")
              .setControlName(TemplateFormPlainText + template.report_template_key)
              .createFormControl(template.plain_text, [])
        ],
          null).setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical).setShow(true)
      );

      let createCustomControl: Function = () => {
        tempSections.push(
          customFormSection = new IcepanelsectionSettings(
            TemplateCustomFormSection, { class: [], styles: { width: "100%" } }, [], [
            customFormControl = new IcecontrolSettings("icecustomform", { width: "100%" }, null, null, "CustomFormControl" + template.template_report_key)
              .createFormControl(noteBookOb, [])
          ],
            null).setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical).setShow(true)
        );
      };

      let createLodgeDataAndSection: Function = () => {
        // Add the Lodge option
        let existingOpts = formSelectCtrl.getOptions();
        existingOpts.push({ name: "Standard Membership Summary Form", value: "LODGE_MEMBERSHIP_SUMMARY" });
        formSelectCtrl.setOptions(existingOpts);

        // Now make sure the data will be available
        let fndLodge = template.LODGE_MEMBERSHIP_SUMMARY.filter(l => l.key == template.report_template_key);
        if (fndLodge.length > 0) {
          lodgeMemSummary = fndLodge[0];
        }
        else {
          if (template.LODGE_MEMBERSHIP_SUMMARY.length == 0) {
            lodgeMemSummary = new lodgemembershipsummary();
            lodgeMemSummary.key = template.report_template_key;
            template.LODGE_MEMBERSHIP_SUMMARY.push(lodgeMemSummary);
          }
          else if (template.LODGE_MEMBERSHIP_SUMMARY.length > 0) {
            lodgeMemSummary = template.LODGE_MEMBERSHIP_SUMMARY[0];
            if (lodgeMemSummary.key.length == 0) {
              lodgeMemSummary.key = template.report_template_key;
            }
          }
        }
        if (nbData != null) {
          nbData[lodgeMemSummary.gettablename()] = lodgeMemSummary;
        }

        // Add the Lodge standard view
        lodgeMemSummarySection = this.viewLodgeMembership(lodgeMemSummary);
        tempSections.push(lodgeMemSummarySection);
      };

      let loadAdditionalInformation: Function = (formKey: string) => {
        if (formKey != "" && formKey != "LODGE_MEMBERSHIP_SUMMARY") {
          if (lodgeMemSummarySection != null)
            lodgeMemSummarySection.setShow(false);

          plainTextSection.setShow(false);

          if (customFormSection != null) {
            customFormSection.setShow(true);
          }

          this.frmService.getForm(this.apiToUse, this.reportDomain, this.reportDomainType, false, formKey).subscribe(
            frmData => {
              if (frmData == null || frmData.length == 0) return;
              let thisForm: notebookpage = frmData[0];
              template.notebook_page_key = thisForm.notebook_page_key;

              let noteBookPageOb: NotebookPageObject = noteBookOb.getPageByPageKey(thisForm.notebook_page_key);
              if (noteBookPageOb == null) {
                noteBookPageOb = new NotebookPageObject(thisForm);
                noteBookOb.addPage(noteBookPageOb, true);
                noteBookOb.createByDBObject(noteBookPageOb, null);
              }

              if (customFormSection == null) {
                createCustomControl();
              }
              else {
                customFormSection.setShow(true);
              }
            },
            frmErr => {
              console.log(JSON.stringify(this.frmService.getLastErrors()));
            }
          );
        }
        else if (formKey == "LODGE_MEMBERSHIP_SUMMARY") {
          template.notebook_page_key = ""; // reset key

          if (lodgeMemSummarySection == null) {
            createLodgeDataAndSection();
          }
          else {
            lodgeMemSummarySection.setShow(true);
          }

          plainTextSection.setShow(false);
          if (customFormSection != null)
            customFormSection.setShow(false);
        }
        else if (formKey == "") {
          template.notebook_page_key = ""; // reset key
          if (lodgeMemSummarySection != null)
            lodgeMemSummarySection.setShow(false);

          if (customFormSection != null)
            customFormSection.setShow(false);

          plainTextSection.setShow(true);
        }
      };

      formSelectCtrl.createChangeControlEvent().subscribe(
        data => {
          if (data == null) return;

          debugger;
          loadAdditionalInformation(data.value);
        },
        err => {
          console.log(JSON.stringify(this.frmService.getLastErrors()));
        });

      formDesignCtrl.createClickControlEvent().subscribe(
        data => {
          if (data == null) return;
          debugger;
          let nbPage = noteBookOb.getPageByPageKey(formSelectCtrl.getFormControl().value/*noteBookOb.getCurrentPage()*/);
          if (nbPage == null) {
            this.doCustomFormDesignPopup(noteBookOb, nbPage, null, this.reportTemplateOptions, IceTypes.SourceType.srcInfomatics, template.report_template_type, this.reportObj.report_type, "", customFormChange);
            return;
          }
          this.frmService.getFormRaw(this.apiToUse, this.reportDomain, this.reportDomainType, false, nbPage.page.notebook_page_key).subscribe(
            frmRaw => {
              let scriptCode: string = <string>frmRaw;
              if (scriptCode.length > 0) {
                scriptCode = scriptCode.replace("<ICEXDocument>", "");
                scriptCode = scriptCode.replace("<ICEXDocument >", "");
                scriptCode = scriptCode.replace("</ICEXDocument>", "");
              }

              this.doCustomFormDesignPopup(noteBookOb, nbPage, this.allForms[nbPage.page.notebook_page_key], this.reportTemplateOptions, IceTypes.SourceType.srcInfomatics, template.report_template_type, this.reportObj.report_type, Iceutility.formatXmlIndent(scriptCode), customFormChange);
            },
            frmErr => {
              console.log(JSON.stringify(this.frmService.getLastErrors()));
            }
          );
        },
        err => {
          console.log(JSON.stringify(this.frmService.getLastErrors()));
        });

      customFormChange.subscribe(
        data => {
          if (data == null) return;
          if (typeof (data) == "string") {
            Iceutility.yesnomodal(data);
          }
          else {
            let nbPageOb = <NotebookPageObject>data;
            let fndOpts = formSelectCtrl.getOptions().filter(o => o.value == nbPageOb.page.notebook_page_key);
            if (fndOpts.length == 0) {
              formSelectCtrl.getOptions().push({ name: nbPageOb.page.nbpage_name, value: nbPageOb.page.notebook_page_key });
              formSelectCtrl.getFormControl().setValue(nbPageOb.page.notebook_page_key);
            }

            if (customFormSection == null) {
              createCustomControl();
            }
            else {
              setTimeout(() => {
                noteBookOb.initUpdate(customFormControl, IceTypes.ACCOUNT_TYPE.actNone, "", nbPageOb.getPageIndex());
                noteBookOb.setControlData(customFormControl, IceTypes.ACCOUNT_TYPE.actNone, "", nbPageOb.getPageIndex());
              });
            }
          }
        },
        error => {

        });

      this.frmService.getForms(this.apiToUse, this.reportDomain, this.reportDomainType, IceTypes.SourceType.srcInfomatics, - 1).subscribe(
        data => {
          if (data == null || data.length == 0) return;
          let forms: notebookpageindex[] = data;

          let opts = [];
          for (let i = 0; i < forms.length; i++) {
            let frm = forms[i];
            opts.push({ name: frm.nbpage_name, value: frm.notebook_page_key });

            this.allForms[frm.notebook_page_key] = frm;
          }

          let existingOpts = formSelectCtrl.getOptions();
          existingOpts = existingOpts.concat(opts);
          formSelectCtrl.setOptions(existingOpts);
        },
        error => {
          console.log(JSON.stringify(this.frmService.getLastErrors()));
        });


      let fndLodgeAccountingSummary = this.reportTemplateOptions.filter(t => t.value == template.report_template_type && t.code == 'REPTEMPL-ACCT-SUM-LODGE');
      if (fndLodgeAccountingSummary.length > 0) {
        createLodgeDataAndSection();
      }

      if (template.notebook_page_key == "" && fndLodgeAccountingSummary.length > 0) {
        formSelectCtrl.getFormControl().setValue("LODGE_MEMBERSHIP_SUMMARY");
        loadAdditionalInformation("LODGE_MEMBERSHIP_SUMMARY");
      }
      else if (template.notebook_page_key.length > 0) {
        loadAdditionalInformation(template.notebook_page_key);
      }
      else {
        loadAdditionalInformation("");
      }

      let headerControls = [
      ];

      let tempPanelSettings = new IcepanelSettings(TemplatePanelForm, template.report_template_key, "Report Additional Information", "", tempSections, headerControls)
        .enableForm();
      let panels: IcepanelSettings[] = [
        tempPanelSettings
      ];

      let panelrows: IcepanelcontainerRowSettings[] = [new IcepanelcontainerRowSettings(panels)];
      this.templateFormViewSettings[template.report_template_key] = new IcepanelcontainerSettings("TemplateViewContainer", panelrows);
    }
    return this.templateFormViewSettings[template.report_template_key];
  }

  viewLodgeMembership(lodgeMemSummary: lodgemembershipsummary): IcepanelsectionSettings {
    if (lodgeMemSummary == null || lodgeMemSummary.key.length == 0) return null;

    let sec: IcepanelsectionSettings = null;
    try {
      this.lodgeSummary_memberShipReportDateCtrl[lodgeMemSummary.key] = new IcecontrolSettings("icedatepicker", { width: "200px" }, null, null, "MembershipReportDate", "Date of Summary")
        .setControlName("MembershipReportDate")
        .createFormControl(Iceutility.isTextDateTime(lodgeMemSummary.date_of_summary) ? Iceutility.GetLocalDate(lodgeMemSummary.date_of_summary) : Iceutility.ConvertFromDotNetServerTime(lodgeMemSummary.date_of_summary), [Validators.required]);

      this.lodgeSummary_nameOfOrgCtrl[lodgeMemSummary.key] = new IcecontrolSettings("iceinput", { width: "400px" }, null, null, "NameOfOrganization", "Name of Organization")
        .setControlName("NameOfOrganization")
        .createFormControl(lodgeMemSummary.organization_name, [Validators.required]);

      this.lodgeSummary_address1OfOrgCtrl[lodgeMemSummary.key] = new IcecontrolSettings("iceinput", { width: "400px" }, null, null, "Address1OfOrganization", "Address 1")
        .setControlName("Address1OfOrganization")
        .createFormControl(lodgeMemSummary.street1, [Validators.required]);

      this.lodgeSummary_address2OfOrgCtrl[lodgeMemSummary.key] = new IcecontrolSettings("iceinput", { width: "400px" }, null, null, "Address2OfOrganization", "Address 2")
        .setControlName("Address2OfOrganization")
        .createFormControl(lodgeMemSummary.street2, []);

      this.lodgeSummary_cityOfOrgCtrl[lodgeMemSummary.key] = new IcecontrolSettings("iceinput", { width: "400px" }, null, null, "CityOfOrganization", "City")
        .setControlName("CityOfOrganization")
        .createFormControl(lodgeMemSummary.city, [Validators.required]);

      this.lodgeSummary_stateOfOrgCtrl[lodgeMemSummary.key] = new IcecontrolSettings("iceselect", { menuItems: [], width: "475px" }, null, null, "StateOfOrganization", "Enter State")
        .setControlName("StateOfOrganization")
        .createFormControl(lodgeMemSummary.state_id, [Validators.required]);

      this.lodgeSummary_countryOfOrgCtrl[lodgeMemSummary.key] = new IcecontrolSettings("iceselect", { menuItems: [], width: "475px" }, null, null, "CountryOfOrganization", "Enter Country")
        .setControlName("CountryOfOrganization")
        .createFormControl(lodgeMemSummary.country_id, [Validators.required]);

      this.appSvc.setStateIDList(this.codeSvc, this.lodgeSummary_stateOfOrgCtrl[lodgeMemSummary.key], "");
      this.appSvc.setCountryCodeList(this.codeSvc, this.lodgeSummary_countryOfOrgCtrl[lodgeMemSummary.key]);

      this.lodgeSummary_postalCodeOfOrgCtrl[lodgeMemSummary.key] = new IcecontrolSettings("iceinput", { width: "400px" }, null, null, "PostalCodeOfOrganization", "Postal Code")
        .setControlName("PostalCodeOfOrganization")
        .createFormControl(lodgeMemSummary.postal_code, [Validators.required]);

      this.lodgeSummary_provinceOfOrgCtrl[lodgeMemSummary.key] = new IcecontrolSettings("iceinput", { width: "400px" }, null, null, "ProvinceOfOrganization", "Province")
        .setControlName("ProvinceOfOrganization")
        .createFormControl(lodgeMemSummary.province, []);

      this.lodgeSummary_charterNumberCtrl[lodgeMemSummary.key] = new IcecontrolSettings("iceinput", { width: "100px" }, null, null, "MembershipCharterNumber", "Local Number")
        .setControlName("MembershipCharterNumber")
        .createFormControl(lodgeMemSummary.charter_number, [Validators.required]);

      this.lodgeSummary_memberShipReportStartDateCtrl[lodgeMemSummary.key] = new IcecontrolSettings("icedatepicker", { width: "200px" }, null, null, "MembershipReportStartDate", "Starting Date of Reporting Period")
        .setControlName("MembershipReportStartDate")
        .createFormControl(Iceutility.isTextDateTime(lodgeMemSummary.starting_date) ? Iceutility.GetLocalDate(lodgeMemSummary.starting_date) : Iceutility.ConvertFromDotNetServerTime(lodgeMemSummary.starting_date), [Validators.required]);

      this.lodgeSummary_memberShipReportEndDateCtrl[lodgeMemSummary.key] = new IcecontrolSettings("icedatepicker", { width: "200px" }, null, null, "MembershipReportEndDate", "Ending Date of Reporting Period")
        .setControlName("MembershipReportEndDate")
        .createFormControl(Iceutility.isTextDateTime(lodgeMemSummary.ending_date) ? Iceutility.GetLocalDate(lodgeMemSummary.ending_date) : Iceutility.ConvertFromDotNetServerTime(lodgeMemSummary.ending_date), [Validators.required]);

      this.lodgeSummary_functioningStatusCtrl[lodgeMemSummary.key] = new IcecontrolSettings("iceselect", { menuItems: [], width: "200px" }, null, null, "MembershipFunctioningStatus", "Is functioning status")
        .setControlName("MembershipFunctioningStatus")
        .createFormControl(lodgeMemSummary.functioning_status, [Validators.required])
        .setOptions([
          { value: "satisfactorily", name: "Satisfactorily" },
          { value: "having problems", name: "Having Problems" },
        ]);

      this.lodgeSummary_numberOfMembersCtrl[lodgeMemSummary.key] = new IcecontrolSettings("iceinput", { width: "100px" }, null, null, "MembershipNumberOfMembers", "Number of Members")
        .setControlName("MembershipNumberOfMembers")
        .createFormControl(lodgeMemSummary.number_of_members, [Validators.required]);

      this.lodgeSummary_activeMembersCtrl[lodgeMemSummary.key] = new IcecontrolSettings("iceinput", { width: "100px" }, null, null, "MembershipActiveMembers", "Active Members")
        .setControlName("MembershipActiveMembers")
        .createFormControl(lodgeMemSummary.active_members, [Validators.required]);

      this.lodgeSummary_meetingLocationCtrl[lodgeMemSummary.key] = new IcecontrolSettings("iceinput", { width: "400px" }, null, null, "MembershipMeetingLocation", "Meeting Dates and Location")
        .setControlName("MembershipMeetingLocation")
        .createFormControl(lodgeMemSummary.meeting_location, [Validators.required]);

      this.lodgeSummary_activitiesCtrl[lodgeMemSummary.key] = new IcecontrolSettings("icetextarea", { width: "400px" }, null, null, "MembershipActivities", "Activities and Functions held during the month")
        .setControlName("MembershipActivities")
        .createFormControl(lodgeMemSummary.activities, [Validators.required]);

      this.lodgeSummary_otherActivitiesCtrl[lodgeMemSummary.key] = new IcecontrolSettings("icetextarea", { width: "400px" }, null, null, "MembershipOtherActivity", "Other Activities")
        .setControlName("MembershipOtherActivity")
        .createFormControl(lodgeMemSummary.other_activities, []);

      this.lodgeSummary_transferName1Ctrl[lodgeMemSummary.key] = new IcecontrolSettings("iceinput", { width: "200px" }, null, null, "MembershipTransferName1", "Transfer Name 1")
        .setControlName("MembershipTransferName1")
        .createFormControl(lodgeMemSummary.transfer_name1, []);

      this.lodgeSummary_transferTo1Ctrl[lodgeMemSummary.key] = new IcecontrolSettings("iceinput", { width: "100px" }, null, null, "MembershipTransferTo1", "Transfer To 1")
        .setControlName("MembershipTransferTo1")
        .createFormControl(lodgeMemSummary.transfer_to_charter1, []);

      this.lodgeSummary_transferEffectiveDate1Ctrl[lodgeMemSummary.key] = new IcecontrolSettings("icedatepicker", { width: "200px" }, null, null, "MembershipTransferEffectiveDate1", "Transfer Effective 1")
        .setControlName("MembershipTransferEffectiveDate1")
        .createFormControl(Iceutility.isTextDateTime(lodgeMemSummary.transfer_effective_date1) ? Iceutility.GetLocalDate(lodgeMemSummary.transfer_effective_date1) : Iceutility.ConvertFromDotNetServerTime(lodgeMemSummary.transfer_effective_date1), []);

      this.lodgeSummary_transferName2Ctrl[lodgeMemSummary.key] = new IcecontrolSettings("iceinput", { width: "200px" }, null, null, "MembershipTransferName2", "Transfer Name 2")
        .setControlName("MembershipTransferName2")
        .createFormControl(lodgeMemSummary.transfer_name2, []);

      this.lodgeSummary_transferTo2Ctrl[lodgeMemSummary.key] = new IcecontrolSettings("iceinput", { width: "100px" }, null, null, "MembershipTransferTo2", "Transfer To 2")
        .setControlName("MembershipTransferTo2")
        .createFormControl(lodgeMemSummary.transfer_to_charter2, []);

      this.lodgeSummary_transferEffectiveDate2Ctrl[lodgeMemSummary.key] = new IcecontrolSettings("icedatepicker", { width: "200px" }, null, null, "MembershipTransferEffectiveDate2", "Transfer Effective 2")
        .setControlName("MembershipTransferEffectiveDate2")
        .createFormControl(Iceutility.isTextDateTime(lodgeMemSummary.transfer_effective_date2) ? Iceutility.GetLocalDate(lodgeMemSummary.transfer_effective_date2) : Iceutility.ConvertFromDotNetServerTime(lodgeMemSummary.transfer_effective_date2), []);

      this.lodgeSummary_remitPeriodCtrl[lodgeMemSummary.key] = new IcecontrolSettings("iceselect", { menuItems: [], width: "200px" }, null, null, "MembershipPeriod", "Remit Month")
        .setControlName("MembershipPeriod")
        .createFormControl(lodgeMemSummary.remit_period, [Validators.required])
        .setOptions([
          { value: "January", name: "January" },
          { value: "February", name: "February" },
          { value: "March", name: "March" },
          { value: "April", name: "April" },
          { value: "May", name: "May" },
          { value: "June", name: "June" },
          { value: "July", name: "July" },
          { value: "August", name: "August" },
          { value: "September", name: "September" },
          { value: "October", name: "October" },
          { value: "November", name: "November" },
          { value: "December", name: "December" },
        ]);

      this.lodgeSummary_remittedAmountCtrl[lodgeMemSummary.key] = new IcecontrolSettings("iceinput", { width: "100px" }, null, null, "MembershipRemittedAmount", "Amount Remitted")
        .setControlName("MembershipRemittedAmount")
        .createFormControl(lodgeMemSummary.remitted_amount, [Validators.required]);

      this.lodgeSummary_suggestionsCtrl[lodgeMemSummary.key] = new IcecontrolSettings("icetextarea", { width: "400px" }, null, null, "MembershipSuggestions", "Suggestions")
        .setControlName("MembershipSuggestions")
        .createFormControl(lodgeMemSummary.suggestions, []);

      sec = new IcepanelsectionSettings(
        "LodgeMembershipSection", { class: [], styles: { width: "100%" } }, [], [
          this.lodgeSummary_memberShipReportDateCtrl[lodgeMemSummary.key],
          this.lodgeSummary_charterNumberCtrl[lodgeMemSummary.key],
          this.lodgeSummary_nameOfOrgCtrl[lodgeMemSummary.key],
          this.lodgeSummary_address1OfOrgCtrl[lodgeMemSummary.key],
          this.lodgeSummary_address2OfOrgCtrl[lodgeMemSummary.key],
          this.lodgeSummary_cityOfOrgCtrl[lodgeMemSummary.key],
          this.lodgeSummary_postalCodeOfOrgCtrl[lodgeMemSummary.key],
          this.lodgeSummary_countryOfOrgCtrl[lodgeMemSummary.key],
          this.lodgeSummary_stateOfOrgCtrl[lodgeMemSummary.key],
          this.lodgeSummary_provinceOfOrgCtrl[lodgeMemSummary.key],
          this.lodgeSummary_memberShipReportStartDateCtrl[lodgeMemSummary.key],
          this.lodgeSummary_memberShipReportEndDateCtrl[lodgeMemSummary.key],
          this.lodgeSummary_functioningStatusCtrl[lodgeMemSummary.key],
          this.lodgeSummary_numberOfMembersCtrl[lodgeMemSummary.key],
          this.lodgeSummary_activeMembersCtrl[lodgeMemSummary.key],
          this.lodgeSummary_meetingLocationCtrl[lodgeMemSummary.key],
          this.lodgeSummary_activitiesCtrl[lodgeMemSummary.key],
          this.lodgeSummary_otherActivitiesCtrl[lodgeMemSummary.key],
          this.lodgeSummary_transferName1Ctrl[lodgeMemSummary.key],
          this.lodgeSummary_transferTo1Ctrl[lodgeMemSummary.key],
          this.lodgeSummary_transferEffectiveDate1Ctrl[lodgeMemSummary.key],
          this.lodgeSummary_transferName2Ctrl[lodgeMemSummary.key],
          this.lodgeSummary_transferTo2Ctrl[lodgeMemSummary.key],
          this.lodgeSummary_transferEffectiveDate2Ctrl[lodgeMemSummary.key],
          this.lodgeSummary_remitPeriodCtrl[lodgeMemSummary.key],
          this.lodgeSummary_remittedAmountCtrl[lodgeMemSummary.key],
          this.lodgeSummary_suggestionsCtrl[lodgeMemSummary.key],
          //new IcecontrolSettings("icepanelbutton", { text: "Reset", class: [], glyphClass: "fa-plus" }, null, null, "MembershipResetButton"),
      ], null).setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical).setShow(true);
    }
    catch (e) {
      console.log(e);
    }
    return sec;
  }

  viewSetup(rep: report): IcepanelcontainerSettings {
    let setup: IcepanelcontainerSettings = null;
    try {
      if (rep == null) {
        rep = new report();
        rep.rpt_name = "Untitled";
      }

      this.reportObj = rep;
      this.reportObj.report_type = <IceTypes.ReportType>this.reportObj.report_type;

      this.nameOfReportCtrl = new IcecontrolSettings("iceinput", { width: "250px" }, null, null, NameOfReport, "Name of Report")
        .setControlName(NameOfReport)
        .createFormControl(this.reportObj.rpt_name, [Validators.required]);
      this.typeOfReportCtrl = new IcecontrolSettings("iceselect", { menuItems: ReportService.getReportTypes(), width: "250px" }, null, null, TypeOfReport, "Type of Report")
        .setControlName(TypeOfReport)
        .createFormControl(this.reportObj.report_type, [Validators.required]);
      this.runFrequencyCtrl = new IcecontrolSettings("iceselect", { menuItems: ScheduleService.getRecurringTypes(), width: "250px" }, null, null, RunFrequency, "Run Frequency")
        .setControlName(RunFrequency)
        .createFormControl(this.reportObj.recurring_type, [Validators.required]);

      let panelTag = "ReportView";
      let panelKey = Iceutility.guid(false);
      let controls: IcecontrolSettings[] = [
        this.nameOfReportCtrl,
        this.typeOfReportCtrl,
        this.runFrequencyCtrl,
      ];

      this.reportSections = [
        new IcepanelsectionSettings("TitleSection", { class: ["yalla"], styles: { width: "100%" } }, null, controls, null)
          .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical),
        new IcepanelsectionSettings("TemplateSection", { class: [], styles: { width: "100%" } }, [], [], null)
      ];

      let headerControls = [
        new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px" }, null, null, SaveReport),
        new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px" }, null, null, CancelReport)
      ];

      this.reportPanelSettings = new IcepanelSettings(panelTag, panelKey, "Report", "", this.reportSections, headerControls)
        .enableForm();
      let panels: IcepanelSettings[] = [
        this.reportPanelSettings
      ];

      let panelrows: IcepanelcontainerRowSettings[] = [new IcepanelcontainerRowSettings(panels)];
      setup = new IcepanelcontainerSettings("ReportViewContainer", panelrows);

      this.templateDataSource.data = this.reportObj.RPTTEMPLATES;

      this.codeSvc.getCodes("SUBTYPE_ITEM", "", "", "", "", IceTypes.ACCOUNT_TYPE.actNone).subscribe(
        data => {
          if (data != null) {
            let repOpts = data.filter(c => c.code.indexOf("REPTEMPL-") >= 0).map(c => { return { value: c.sub_type, name: c.title, code: c.code, keyword: c.keyword, category_type: c.category_type } });
            this.reportTemplateOptions = this.reportTemplateOptions.concat(repOpts);
          }
        },
        error => {
        });
    }
    catch (e) {
      console.log(e);
    }
    return setup;
  }

  doTemplatePopup(templ: reporttemplate) {
    if (templ == null) return;

    let templateCtrl: IcecontrolSettings = null, countryCtrl: IcecontrolSettings = null, stateCtrl: IcecontrolSettings = null;
    let sections: IcepanelsectionSettings[] = [
      new IcepanelsectionSettings("TemplateSelectionSection", { class: ["yalla"], styles: {} }, [],
        [templateCtrl = new IcecontrolSettings("iceselect", { width: "400px" }, null, null, "Template", "Template")
          .setControlName("report_template_type")
          .createFormControl(Iceutility.toLong(templ.report_template_type), [Validators.required])
          .setOptions(this.reportTemplateOptions.filter(o => o.category_type == this.reportObj.report_type))], null),
    ];

    let headerControls = [
      new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px" }, null, null, "Save"),
      new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px" }, null, null, "Close")
    ];

    this.templateDialogRef = this.dialog.open(IcepanelDialog, {
      height: '400px',
      width: '500px',
      data: {
        record: templ,
        parentrecord: null,
        panel: new IcepanelSettings("", "", "Template", "", sections, headerControls)
          .enableForm(),
      }
    });

    var ref = this.templateDialogRef;
    this.templateDialogRef.afterClosed().subscribe(result => {
      if (ref.componentInstance == null || ref.componentInstance.data == null) return;
      let hdrCtrl: IcecontrolSettings = <IcecontrolSettings>ref.componentInstance.data.headerCtrl;
      if (hdrCtrl == null || hdrCtrl.id == "Close") return;

      let tp: reporttemplate = <reporttemplate>ref.componentInstance.data.record;
      let panel: IcepanelSettings = <IcepanelSettings>ref.componentInstance.data.panel;
      if (panel != null && tp != null) {
        let form = panel.getForm();
        if (form != null && form.valid) {
          for (let isec = 0; isec < panel.sections.length; isec++) {
            let sec = panel.sections[isec];
            for (let ictrl = 0; ictrl < sec.controls.length; ictrl++) {
              let ctrl = sec.controls[ictrl];
              switch (ctrl.getControlName()) {
                case "report_template_type": {
                  tp.report_template_type = ctrl.getFormControl().value;
                  break;
                }
              }
            }
          }
          if (tp.report_template_key.length == 0) {
            tp.report_template_key = Iceutility.guid(true);
            this.reportObj.RPTTEMPLATES.push(tp);
          }
          this.changeDetectorRefs.detectChanges();
        }
      }
    });
  }

  doCustomFormDesignPopup(notebookOb: NotebookObject, nbPageOb: NotebookPageObject, nbPageIdx: notebookpageindex, reportTypeOptions: any[], defaultSrcType: IceTypes.SourceType, defaultSubType: number, defaultCategoryType: number, rawform: string, eEmitter: EventEmitter<any>) {
    if (notebookOb == null) return;

    if (rawform == null || rawform.length == 0) {
      rawform = Iceutility.formatXmlIndent("<NOTEBOOK_PAGE><NOTEBOOK_PAGE_KEY></NOTEBOOK_PAGE_KEY><NBPAGE_NAME>Untitled Form</NBPAGE_NAME><ITEMS><!--Add Your Code Here--></ITEMS></NOTEBOOK_PAGE>");
    }
    let formTypeData = new MatTableDataSource<any>([]);
    formTypeData.data = reportTypeOptions.filter(o => o.category_type == defaultCategoryType);

    let scriptCtrl: IcecontrolSettings = null;
    let sections: IcepanelsectionSettings[] = [
      new IcepanelsectionSettings("CodeSection", { class: ["yalla"], styles: {} }, [],
        [scriptCtrl = new IcecontrolSettings("icetextarea", { width: "600px", height: "580px", rows: "20", cols: "80", maxLength: rawform.length + 10000 }, null, null, "Script", "Script for Form")
          .setControlName("formscript")
          .createFormControl(rawform, [])], null),
    ];

    if (nbPageOb != null) {
      if (nbPageIdx != null) {
        let nbtypes = nbPageIdx.types.split(',');
        for (let ityp = 0; ityp < formTypeData.data.length && nbtypes.length > 0; ityp++) {
          let typ = formTypeData.data[ityp];
          if (typ != null) {
            let fndNBTyp = nbtypes.filter(nbtyp => nbtyp == typ.value);
            if (fndNBTyp.length > 0) {
              typ["typeSelect"] = true;
            }
          }
        }
      }

      let selectedTypeCtrl = new IcecontrolSettings("icecheckbox", { width: "50px", cursor: 'pointer' }, null, null, null)
        .setControlName()
        .createFormControl(false, []); // To do: fix this as it is not working formgroup

      let selectedTables: IcemattableSettings[] = [
        new IcemattableSettings(
          "SelectedTable",
          [
            new iceColumnDefinition("typeSelect", "Types", false, false,
              selectedTypeCtrl
            ),
            new iceColumnDefinition("name", "Name", false, false,
              new IcecontrolSettings("icelabel", { width: "75px", cursor: 'pointer' }, null, null)),
            new iceColumnDefinition("value", "value", true),
          ],
          formTypeData,
          [],
          false,
          null,
          true
        )
      ];
      let selectedGroups: IcepanelgroupSettings[] = [
        new IcepanelgroupSettings(null, selectedTables)
      ];

      sections.push(new IcepanelsectionSettings("TypeSelectionSection", { class: [], styles: { width: "100%" } }, selectedGroups, [], null));
    }

    let headerControls = [
      new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px" }, null, null, "Save"),
      new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px" }, null, null, "Close")
    ];

    this.customFormDialogRef = this.dialog.open(IcepanelDialog, {
      height: '500px',
      width: '720px',
      data: {
        record: notebookOb,
        parentrecord: null,
        panel: new IcepanelSettings("", "", "Custom Form", "", sections, headerControls)
          .enableForm(),
      }
    });

    var ref = this.customFormDialogRef;
    this.customFormDialogRef.afterClosed().subscribe(result => {
      if (ref.componentInstance == null || ref.componentInstance.data == null) return;
      let hdrCtrl: IcecontrolSettings = <IcecontrolSettings>ref.componentInstance.data.headerCtrl;
      if (hdrCtrl == null || hdrCtrl.id == "Close") return;

      let nbOb: NotebookObject = <NotebookObject>ref.componentInstance.data.record;
      let panel: IcepanelSettings = <IcepanelSettings>ref.componentInstance.data.panel;
      if (panel != null && nbOb != null) {
        let form = panel.getForm();
        if (form != null && form.valid) {
          for (let isec = 0; isec < panel.sections.length; isec++) {
            let sec = panel.sections[isec];
            for (let ictrl = 0; ictrl < sec.controls.length; ictrl++) {
              let ctrl = sec.controls[ictrl];
              switch (ctrl.getControlName()) {
                case "formscript": {
                  rawform = ctrl.getFormControl().value;
                  rawform = rawform.replace(/[\r\n]/g, '');
                  rawform = rawform.trim();
                  break;
                }
              }
            }
          }

          let updatedPage = nbOb.getFormService().parseForm("<ICEXDocument>" + rawform + "</ICEXDocument>");
          if (updatedPage != null && updatedPage.length > 0) {
            nbOb.getFormService().insertUpdateForm(this.apiToUse, this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), updatedPage[0]).subscribe(
              data => {
                if (data == null || data.length == 0) return;
                let nbpage: notebookpage = data[0];
                if (nbpage == null) return;

                let nbPage: NotebookPageObject = nbOb.getPageByPageKey(nbpage.notebook_page_key);
                if (nbPage != null) {
                  nbPage.resetItems();
                  nbPage.page = nbpage;
                }
                else {
                  nbPage = new NotebookPageObject(nbpage);
                }

                nbOb.createByDBObject(nbPage, null);

                if ((<notebookpage>updatedPage[0]).notebook_page_key == ""
                  && defaultSubType > 0) {
                  debugger;
                  let nbpType = new notebookpagetotype();
                  nbpType.notebook_page_key = nbPage.page.notebook_page_key;
                  nbpType.src_type = defaultSrcType;
                  nbpType.sub_type = defaultSubType;
                  nbOb.getFormService().insertUpdateFormTypes(this.apiToUse, this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), nbPage.page.notebook_page_key, [nbpType]);
                }
                else {
                  notebookOb.getFormService().getFormTypes(this.apiToUse, this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), nbPageOb.page.notebook_page_key, false).subscribe(
                    typedata => {
                      if (typedata == null || typedata.length == 0) return;

                      let nbtypes = <notebookpagetotype[]>typedata;
                      for (let ityp = 0; ityp < formTypeData.data.length; ityp++) {
                        let typ = formTypeData.data[ityp];
                        if (typ != null && typ["typeSelect"] != null) {
                          debugger;
                          let fndNBTyp = nbtypes.filter(nbtyp => nbtyp.sub_type == typ.value);
                          if (fndNBTyp.length > 0 && typ["typeSelect"] == true) {
                            fndNBTyp[0].offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
                          }
                          else if (fndNBTyp.length > 0 && typ["typeSelect"] == false) {
                            fndNBTyp[0].offline_record_status = IceTypes.offlineRecStatus.offlineDelete;
                          }
                          else if (fndNBTyp.length == 0 && typ["typeSelect"] == true) {
                            let nbpType = new notebookpagetotype();
                            nbpType.notebook_page_key = nbPage.page.notebook_page_key;
                            nbpType.src_type = defaultSrcType;
                            nbpType.sub_type = typ["value"];
                            nbpType.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
                            nbtypes.push(nbpType);
                          }
                        }
                      }

                      nbOb.getFormService().insertUpdateFormTypes(this.apiToUse, this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), nbPage.page.notebook_page_key, nbtypes).subscribe(
                        frmTypData => {
                          // fall through
                        },
                        frmTypErr => {
                          console.log(JSON.stringify(notebookOb.getFormService().getLastErrors()));
                        }
                      );
                    },
                    error => {
                      console.log(JSON.stringify(notebookOb.getFormService().getLastErrors()));
                    });
                }
                if (eEmitter != null) eEmitter.emit(nbPage);
              },
              error => {
                console.log(JSON.stringify(notebookOb.getFormService().getLastErrors()));
              });
          }
          else {
            if (eEmitter != null) eEmitter.emit("Error: Invalid Form Format.");
          }
        }
      }
    });
  }

  ngOnInit() {
    this.appSvc.refreshMenus();
  }

  public onControlChange(event) {
    try {
      if (event.selectSettings != null) {
        switch (event.selectSettings.id) {
        }
      }
    }
    catch (e) {
      console.log(e);
    }
  }

  public onAddRowButtonClick(event) {
  }

  onTemplateButtonClick(event) {
    try {
      let newTpl: reporttemplate = new reporttemplate();
      this.doTemplatePopup(newTpl);
    }
    catch (e) {
      console.log(e);
    }
  }

  onTemplateActionButtonClick(event, template: reporttemplate, action: any): void {
    if (template == null || event == null || action == null) return;
    debugger;
    if (action.value != null && action.value == IceTypes.recordQuickActionRemove.value) {
      if (Iceutility.yesnomodal("Would you like to remove this Template?")) {
        let fndKeepTemplates = this.reportObj.RPTTEMPLATES.filter(t => t.report_template_key != template.report_template_key);
        this.reportObj.RPTTEMPLATES = fndKeepTemplates;
      }
    }
    else if (action.value != null && action.value == IceTypes.recordQuickActionClone.value) {
      if (false == Iceutility.yesnomodal("Would you like to clone this Template?")) {
        return;
      }
      let clone = new reporttemplate(template);
      clone.report_template_key = Iceutility.guid(true);
      this.reportObj.RPTTEMPLATES.push(clone);
    }
  }

  onTemplateTabSelectChange(event, template: reporttemplate) {
    debugger;
    let ctrl: IcecontrolSettings = this.templateTabCtrl[template.report_template_key];
    if (ctrl.properties.tabs != null) {
      let tabAry: TabPropertyBase[] = ctrl.properties.tabs;
      if (tabAry.length > 0 && event < tabAry.length) {
        let tab = tabAry[event];
        this.selectedTemplateTab[template.report_template_key] = tab.id;
        switch (tab.id) {
          case this.templateTabSummary: {
            break;
          }
          case this.templateTabFilter: {
            break;
          }
          case this.templateTabForm: {
            break;
          }
          case this.templateTabReport: {
            break;
          }
        }
      }
    }
  }

  public onHeaderActionClick(event) {
    if (event.headerCtrl && event.headerCtrl.id == CancelReport) {
      // To do: Save Modified Prompt
      this.router.navigate([this.navSvc.buildRoute("reports", false)]);
      return;
    }

    if (event.headerCtrl instanceof IcepanelSettings) {
      let reportPanel: IcepanelSettings = event.headerCtrl;
      let reportForm: FormGroup = reportPanel.getForm();
      if (reportForm == null || false == reportForm.valid) {

        // To do log error
        return;
      }

      this.reportObj.rpt_name = reportForm.get(NameOfReport).value;
      this.reportObj.report_type = <IceTypes.ReportType>Iceutility.toLong(reportForm.get(TypeOfReport).value);
      this.reportObj.recurring_type = <IceTypes.recurringtype>Iceutility.toLong(reportForm.get(RunFrequency).value);
      if (false == Iceutility.isdefined(this.reportObj.RPTTEMPLATES) || this.reportObj.RPTTEMPLATES.length == 0) {
        this.reportObj.RPTTEMPLATES = [];
      }

      for (let itpl = 0; itpl < this.reportObj.RPTTEMPLATES.length; itpl++) {
        debugger;
        let tpl = this.reportObj.RPTTEMPLATES[itpl];

        let templSummaryPanelContainer: IcepanelcontainerSettings = this.templateSummaryViewSettings[tpl.report_template_key];
        if (templSummaryPanelContainer != null && templSummaryPanelContainer.rows.length > 0) {
          let templPanelCntrRow = templSummaryPanelContainer.rows[0];
          if (templPanelCntrRow.columns.length > 0) {
            let fndSummaryPnl = templPanelCntrRow.columns.filter(p => p.tag == TemplatePanelSummary);
            if (fndSummaryPnl.length > 0) {
              let fndTypeSection = fndSummaryPnl[0].sections.filter(s => s.tag == TemplateTypeSection);
              if (fndTypeSection.length > 0) {
                let fndTypeCtrl = fndTypeSection[0].controls.filter(c => c.id == TemplateType + tpl.report_template_key);
                if (fndTypeCtrl.length > 0) {
                  tpl.report_template_type = fndTypeCtrl[0].getFormControl().value;
                }
              }
            }
          }
        }

        let templFilterPanelContainer: IcepanelcontainerSettings = this.templateFilterViewSettings[tpl.report_template_key];
        if (templFilterPanelContainer != null && templFilterPanelContainer.rows.length > 0) {

          let templPanelCntrRow = templFilterPanelContainer.rows[0];
          if (templPanelCntrRow.columns.length > 0) {

            let fromVal = null;
            let toVal = null;

            let fndFilterPnl = templPanelCntrRow.columns.filter(p => p.tag == TemplatePanelFilters);
            if (fndFilterPnl.length > 0) { // To do this will need to support multiple filters
              let filterForm: FormGroup = fndFilterPnl[0].getForm();
              if (filterForm != null && filterForm.valid) {
                fromVal = filterForm.get(FromDate).value;
                let newFrom = fromVal.toLocaleDateString() + " 00:00:00 AM"
                fromVal = Iceutility.GetLocalDate(newFrom);

                toVal = filterForm.get(ToDate).value;
                let newTo = toVal.toLocaleDateString() + " 11:59:59 PM"
                toVal = Iceutility.GetLocalDate(newTo);
              }
            }

            let colname = "";
            let tablename = "";
            switch (this.reportObj.report_type) {
              case IceTypes.ReportType.rtClincialData:
              case IceTypes.ReportType.rtScheduling:
                colname = "time_slot_start";
                tablename = "encounter";
                break;
              case IceTypes.ReportType.rtAccountingSummary:
                colname = "journal_date";
                tablename = "journal";
                break;
            }

            if (colname.length > 0) {

              // Update filter
              let dateAry = tpl.RPTFILTER.filter(f => f.columnname.toLowerCase() == colname || f.columnname == '' || f.columnname == null);

              let dateFilter: reportfilter = null;
              if (dateAry != null && dateAry.length > 0) {
                dateFilter = dateAry[0];
                dateFilter.columnname = colname;
                dateFilter.tablename = tablename;
                dateFilter.operatortype = OperatorTypes.otBetween;
              }
              else {
                dateFilter = new reportfilter();
                tpl.RPTFILTER.push(dateFilter);

                if (dateFilter.columnname == null || dateFilter.columnname.length == 0) {
                  dateFilter.columnname = colname;
                  dateFilter.tablename = tablename;
                }
                dateFilter.operatortype = OperatorTypes.otBetween;
              }

              dateFilter.value = Iceutility.GetDateText(fromVal, "-", true) + "," + Iceutility.GetDateText(toVal, "-", true);
            }
          }
        }

        let templFormPanelContainer: IcepanelcontainerSettings = this.templateFormViewSettings[tpl.report_template_key];
        if (templFormPanelContainer != null && templFormPanelContainer.rows.length > 0) {

          let templPanelCntrRow = templFormPanelContainer.rows[0];
          if (templPanelCntrRow.columns.length > 0) {

            // To do this replaces the "REPTEMPL-ACCT-SUM-LODGE" section below
            let fndCustomDataPnl = templPanelCntrRow.columns.filter(p => p.tag == TemplatePanelForm);
            if (fndCustomDataPnl.length > 0) {
              // get icenotebook ...getdata("LODGE_MEMBERSHIP_SUMMARY")

              let fndTemplateData = this.reportTemplateOptions.filter(t => t.value == tpl.report_template_type);
              if (fndTemplateData.length > 0) {
                switch (fndTemplateData[0].code) {
                  case "REPTEMPL-ACCT-SUM-LODGE": {
                    let lodgeMemSummary: lodgemembershipsummary = null;
                    let fndLodge = tpl.LODGE_MEMBERSHIP_SUMMARY.filter(l => l.key == tpl.report_template_key);
                    if (fndLodge.length > 0) {
                      lodgeMemSummary = fndLodge[0];

                      if (tpl.notebook_page_key.length == 0) {
                        lodgeMemSummary.date_of_summary = Iceutility.convertToUTCEx(this.lodgeSummary_memberShipReportDateCtrl[lodgeMemSummary.key].getFormControl().value);
                        lodgeMemSummary.organization_name = this.lodgeSummary_nameOfOrgCtrl[lodgeMemSummary.key].getFormControl().value;
                        lodgeMemSummary.street1 = this.lodgeSummary_address1OfOrgCtrl[lodgeMemSummary.key].getFormControl().value;
                        lodgeMemSummary.street2 = this.lodgeSummary_address2OfOrgCtrl[lodgeMemSummary.key].getFormControl().value;
                        lodgeMemSummary.city = this.lodgeSummary_cityOfOrgCtrl[lodgeMemSummary.key].getFormControl().value;
                        lodgeMemSummary.postal_code = this.lodgeSummary_postalCodeOfOrgCtrl[lodgeMemSummary.key].getFormControl().value;
                        lodgeMemSummary.country_id = this.lodgeSummary_countryOfOrgCtrl[lodgeMemSummary.key].getFormControl().value;
                        lodgeMemSummary.state_id = this.lodgeSummary_stateOfOrgCtrl[lodgeMemSummary.key].getFormControl().value;
                        lodgeMemSummary.province = this.lodgeSummary_provinceOfOrgCtrl[lodgeMemSummary.key].getFormControl().value;
                        lodgeMemSummary.charter_number = this.lodgeSummary_charterNumberCtrl[lodgeMemSummary.key].getFormControl().value;
                        lodgeMemSummary.starting_date = Iceutility.convertToUTCEx(this.lodgeSummary_memberShipReportStartDateCtrl[lodgeMemSummary.key].getFormControl().value);
                        lodgeMemSummary.ending_date = Iceutility.convertToUTCEx(this.lodgeSummary_memberShipReportEndDateCtrl[lodgeMemSummary.key].getFormControl().value);
                        lodgeMemSummary.functioning_status = this.lodgeSummary_functioningStatusCtrl[lodgeMemSummary.key].getFormControl().value;
                        lodgeMemSummary.number_of_members = this.lodgeSummary_numberOfMembersCtrl[lodgeMemSummary.key].getFormControl().value;
                        lodgeMemSummary.active_members = this.lodgeSummary_activeMembersCtrl[lodgeMemSummary.key].getFormControl().value;
                        lodgeMemSummary.meeting_location = this.lodgeSummary_meetingLocationCtrl[lodgeMemSummary.key].getFormControl().value;
                        lodgeMemSummary.activities = this.lodgeSummary_activitiesCtrl[lodgeMemSummary.key].getFormControl().value;
                        lodgeMemSummary.other_activities = this.lodgeSummary_otherActivitiesCtrl[lodgeMemSummary.key].getFormControl().value;
                        lodgeMemSummary.transfer_name1 = this.lodgeSummary_transferName1Ctrl[lodgeMemSummary.key].getFormControl().value;
                        lodgeMemSummary.transfer_to_charter1 = this.lodgeSummary_transferTo1Ctrl[lodgeMemSummary.key].getFormControl().value;
                        lodgeMemSummary.transfer_effective_date1 = Iceutility.convertToUTCEx(this.lodgeSummary_transferEffectiveDate1Ctrl[lodgeMemSummary.key].getFormControl().value);
                        lodgeMemSummary.transfer_name2 = this.lodgeSummary_transferName2Ctrl[lodgeMemSummary.key].getFormControl().value;
                        lodgeMemSummary.transfer_to_charter2 = this.lodgeSummary_transferTo2Ctrl[lodgeMemSummary.key].getFormControl().value;
                        lodgeMemSummary.transfer_effective_date2 = Iceutility.convertToUTCEx(this.lodgeSummary_transferEffectiveDate2Ctrl[lodgeMemSummary.key].getFormControl().value);
                        lodgeMemSummary.remit_period = this.lodgeSummary_remitPeriodCtrl[lodgeMemSummary.key].getFormControl().value;
                        lodgeMemSummary.remitted_amount = this.lodgeSummary_remittedAmountCtrl[lodgeMemSummary.key].getFormControl().value;
                        lodgeMemSummary.suggestions = this.lodgeSummary_suggestionsCtrl[lodgeMemSummary.key].getFormControl().value;
                      }
                      else {
                        let custGrpForm: FormGroup = fndCustomDataPnl[0].getForm();
                        // To do validate form before save

                        let fndCustomFormSec = fndCustomDataPnl[0].sections.filter(sec => sec.tag == TemplateCustomFormSection);
                        if (fndCustomFormSec.length > 0) {
                          let sec = fndCustomFormSec[0];
                          for (let ictrl = 0; ictrl < sec.controls.length; ictrl++) {
                            let ctrl = sec.controls[ictrl];
                            if (ctrl.id == "CustomFormControl" + tpl.template_report_key) {
                              let notebookOb: NotebookObject = ctrl.getFormControl().value;
                              if (notebookOb != null) {
                                if (notebookOb.getControlData() == false) {
                                  // To do notify user
                                  return;
                                }
                              }
                            }
                          }
                        }
                      }
                    }

                    break;
                  }
                }
              }
            }
          }
        }
      }

      let acttype = this.appSvc.getCurrentAccountType();
      switch (acttype) {
        case IceTypes.ACCOUNT_TYPE.actFacility:
        case IceTypes.ACCOUNT_TYPE.actProvider:
          this.apiToUse = "providers";
          break;
        case IceTypes.ACCOUNT_TYPE.actPharmacy:
          this.apiToUse = "pharmacies";
          break;
        case IceTypes.ACCOUNT_TYPE.actPayer:
          this.apiToUse = "payers";
          break;
        default:
          this.rptService.logMessage(IceTypes.LOGTYPE.ltError, "Error reporting API not supported. ");
          return;
      }

      this.rptService.updateReport(this.apiToUse, this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), this.reportObj).subscribe(
        data => {
          this.router.navigate([this.navSvc.buildRoute("viewreport/" + this.reportObj.report_key, false)]);
        },
        error => {
          console.log(JSON.stringify(this.rptService.getLastErrors()));
        });
    }
  }
}
